<!-- <nav class="navigation">
    <ul>
        <li *ngFor="let item of list" routerLinkActive="active">
            <a [routerLink]="item.attr_url" routerLinkActive="active">{{ item.attr_name }}</a>
            <span></span>
        </li>
    </ul>
</nav> -->


<!--
<ul class="ff-left">
    <div class="ff-left-tit"v><span>Single Search</span><i class="fas fa-angle-double-left"></i></div>
    <li><a href="">MLB<i class="fas fa-chevron-down"></i></a>
        <ul>
            <li *ngFor="let item of list" routerLinkActive="active">
                <a [routerLink]="item.attr_url" routerLinkActive="active">{{ item.attr_name }}</a>
                <span></span>
            </li>
        </ul>
    </li>
    <li><a href="#">MLB KID<i class="fas fa-chevron-up"></i></a></li>
</ul>
-->

<ul class="ff-left" [style.width]="isOpen ? '200px' : '30px'">
    <div class="ff-left-tit"><span [style.display]="isOpen ? 'block' : 'none'">Single Search</span>
		<fa-icon (click)="toggle()" [style.display]="isOpen ? 'inline-block' : 'none'" [icon]="faAngleDoubleLeft"></fa-icon>
        <fa-icon (click)="toggle()" [style.display]="isOpen ? 'none' : 'inline-block'" [icon]="faAngleDoubleRight"></fa-icon>
	</div>
    <li [style.display]="isOpen ? 'block' : 'none'"><a href="">MLB<i class="fas fa-chevron-down"></i></a>
        <ul>
            <li *ngFor="let item of list">
                <a [routerLink]="item.attr_url" routerLinkActive="active">{{ item.attr_name }}</a>
                <span></span>
            </li>
        </ul>
    </li>
    <li [style.display]="isOpen ? 'block' : 'none'"><a href="#">MLB KID<i class="fas fa-chevron-up"></i></a></li>
</ul>